<datex-list [items]="items"
            [pageSize]="pageSize"
            [(pageSkip)]="pageSkip"
            [totalCount]="totalCount"
            [loadingStatus]="loadingStatus"
            (loadMore)="$dataLoad()">

  <ng-container topToolbar>
  </ng-container>


  <ng-template listItemDef
               let-item>
    <FootprintManager-licenseplate_content_card
    [licenseplateId]="item.$content_FootprintManager_licenseplate_content_card_inParams_licenseplateId"
    [lotId]="item.$content_FootprintManager_licenseplate_content_card_inParams_lotId"
    [packagingId]="item.$content_FootprintManager_licenseplate_content_card_inParams_packagingId"
    ($refreshEvent)="$refreshEvent.emit()"
    >
    </FootprintManager-licenseplate_content_card>
  </ng-template>

</datex-list>